import * as React from "react";
import type { SVGProps } from "react";
const CloudyPanelIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M2 14a4 4 0 0 0 4 4h13.5a2.5 2.5 0 1 0-.544-4.94q.044-.275.044-.56a3.5 3.5 0 0 0-3.095-3.477A5.002 5.002 0 0 0 6 10a4 4 0 0 0-4 4" clipRule="evenodd" /></svg>;
export default CloudyPanelIcon;